import {
  ADMIN_CLOSE_ENDPOINT,
  ADMIN_REVIEW_ENDPOINT,
  callAPI,
} from "./callAPI";

export async function reviewService({
  service,
  id,
  isSubscription = false,
  employerId = null,
  dailyNotificationType,
}) {
  const body = {
    service,
    id,
    isSubscription,
    employerId,
    dailyNotificationType,
  };

  try {
    return await callAPI({
      endpoint: ADMIN_REVIEW_ENDPOINT,
      opts: {
        body: body,
      },
    });
  } catch (e) {
    console.log(e);
    throw e;
  }
}

export async function closeService({
  service,
  id,
  employerId = null,
  viewCount = null,
}) {
  const body = {
    service,
    id,
    employerId,
    viewCount,
  };

  try {
    return await callAPI({
      endpoint: ADMIN_CLOSE_ENDPOINT,
      opts: {
        body: body,
      },
    });
  } catch (e) {
    console.log(e);
    throw e;
  }
}
